import { render } from "./KelurahanDetail.vue?vue&type=template&id=35a48947"
import script from "./KelurahanDetail.vue?vue&type=script&lang=js"
export * from "./KelurahanDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__